import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";
import { AuditoriaIndicadores } from "../../models/auditoria_indicadores_lista";
import { IGetAllIndicadoresUseCase } from "../../../presentation/useCases/read/get_all_auditor_indicadores_use_case";

export class GetAllIndicadoresUseCase
  extends BasePaginatedUseCase<AuditoriaIndicadores>
  implements IGetAllIndicadoresUseCase {
  constructor(private readonly repository: IAuditorRepository) {
    super();
  }

  async getAllListagemIndicadores(): Promise<AuditoriaIndicadores> {

    const response = await this.repository.getAllListagemIndicadores();
    return response;
  }
}
